import { animated, useSpring } from '@react-spring/web';
import { Button, Card, Typography, useMobile } from '@sonnen/web-ui';
import clsx from 'clsx';
import { useEffect } from 'react';
import { useAppContext } from '../../AppContext/AppContext';
import ElectricityTariffs700 from '../../assets/images/ElectricityTariffs_mobile.webp';
import ElectricityTariffs1400 from '../../assets/images/ElectricityTariffs_wide.webp';
import CroppedImage from '../../components/CroppedImage/CroppedImage';
import { LoadingSpinner } from '../../components/LoadingSpinner/LoadingSpinner';
import { OrderFlowPage } from '../../components/OrderFlowPage/OrderFlowPage';
import { AppRoute } from '../../constants';
import { useTopScrollNavigate } from '../../hooks/useTopScrollNavigate';
import { useTranslation } from '../../i18n/i18n';
import { useOfferContext } from '../../OfferContext/OfferContext';
import styles from './EnergyStore.module.css';

const EnergyStore = () => {
  const { t } = useTranslation();
  const mobile = useMobile();
  const navigate = useTopScrollNavigate();
  const { setOrderFlow, userProcessing, setCurrentBackground } = useAppContext();
  const { setOffer } = useOfferContext();

  useEffect(() => {
    setOrderFlow(null);
  }, [setOrderFlow]);

  useEffect(() => {
    setOffer(null);
  }, [setOffer]);

  useEffect(() => {
    setCurrentBackground();
  }, [setCurrentBackground]);

  const props = useSpring({
    from: { scale: 0.96 },
    to: { scale: 1 },
    config: { tension: 200, friction: 20 },
  });

  return (
    <>
      {userProcessing && (
        <div className={styles.loadingSpinner}>
          <LoadingSpinner text={t('loadingUserDetails')} />
        </div>
      )}
      <OrderFlowPage
        dataTestId="energy-store"
        className={clsx(styles.loadable, {
          [styles.loading]: userProcessing,
        })}
      >
        <div className={styles.heading5}>
          <Typography.H5>{t('energyStore.tariffs.title')}</Typography.H5>
        </div>
        <animated.div style={props}>
          <Card
            paddingSize="none"
            withBottomSpace={false}
            data-testid="electricity-tariffs-card"
            className={styles.electricityTariffsCard}
          >
            <CroppedImage
              height={mobile ? 400 : 640}
              src={mobile ? ElectricityTariffs700 : ElectricityTariffs1400}
              srcSet={mobile ? `${ElectricityTariffs700} 1x` : `${ElectricityTariffs1400} 1x`}
              objectPosition="left top"
              dataTestId="electricity-tariffs-image"
            />

            <Card paddingSize="md" withBottomSpace={false} className={styles.content}>
              <Typography.H2 variant="on-colour">
                {t('energyStore.tariffs.card.title')}
              </Typography.H2>

              <Typography.Body1 variant="on-colour">
                {t('energyStore.tariffs.card.text')}
              </Typography.Body1>

              <Button
                label={t('energyStore.tariffs.card.button')}
                dataTestId="electricity-tariffs-card-btn"
                onClick={() => navigate(AppRoute.TARIFFS_COMPARISON)}
                size="medium"
                expanded
              />
            </Card>
          </Card>
        </animated.div>
      </OrderFlowPage>
    </>
  );
};

export default EnergyStore;
